
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, UntypedFormGroup } from '@angular/forms';
import { BaseComponent } from '@carm/_utils/base.component';

@Component({
  selector: 'carm-base-input',
  template: `carm-base-form`,
})
export class BaseInputComponent extends BaseComponent implements OnInit {

    @Output() inputfocus = new EventEmitter();
    @Output() inputblur = new EventEmitter();
    @Output() keyup = new EventEmitter();
    @Output() keypress = new EventEmitter();

    @Input() group: UntypedFormGroup | FormGroup;
    @Input() controlName: string;
    @Input() type = 'text';
    @Input() inId: string;
    @Input() inClass: string;
    @Input() inStyle;
    @Input() isRequired: boolean = false;
    @Input() inLabel: string;
    @Input() inSize = 30; // default
    @Input() inHint: string;
    @Input() placeholder: string;
    @Input() inDisplayControlOnly = false;  // if true, do not display label and error
    /* Optional is complete status, shows field as a checked off, no longer editable label */
    @Input() inDataCy: string;

    @Input() labelPlacement: 'above' | 'left' = 'above';
    @Input() errorPlacement: 'top' | 'right' = 'top';
    @Input() inGroup = false;
    @Input() preLabel: string;
    @Input() extraInputInfo: string;

    //formControl: AbstractControl;

    constructor(){
      super();
    }

    get formControl(): AbstractControl| null {
      return this.group?.get(this.controlName) ?? null;
    }


    ngOnInit(): void {
      // if (this.inGroup && this.group) {
      //   this.formControl = this.group;
      //   return;
      // }

      // if (this.group && this.controlName && this.group.get(this.controlName)) {
      //   this.formControl = this.group.get(this.controlName);
      // }
    }
}
